export const NO_NOTIFICATION = "NO_NOTIFICATION";
export const LOGGED_OUT_WARNING_NOTIFICATION =
  "LOGGED_OUT_WARNING_NOTIFICATION";
export const EMAIL_NOT_SENT_NOTIFICATION =
  "EMAIL_NOT_SENT_NOTIFICATION";  
export const SIGNED_OUT_SUCCESSFULLY_NOTIFICATION =
  "SIGNED_OUT_SUCCESSFULLY_NOTIFICATION";
export const INCORRECT_CREDENTIALS_NOTIFICATION =
  "INCORRECT_CREDENTIALS_NOTIFICATION";
export const PASSWORD_EXPIRED_NOTIFICATION = "PASSWORD_EXPIRED_NOTIFICATION";
export const SERVER_ERROR_NOTIFICATION = "SERVER_ERROR_NOTIFICATION";

export const REQUEST_ACTION_TYPE = "REQUEST_ACTION_TYPE";
export const SUCCESS_ACTION_TYPE = "SUCCESS_ACTION_TYPE";
export const FAILURE_ACTION_TYPE = "FAILURE_ACTION_TYPE";

export const RESET = "RESET";
